import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

class Filter {

  duration = 0.2;
  stagger = 0.05;
  x = 20;

  constructor($el) {
    this.$el = $el;
    this.$select = this.$el.find('[data-filter="select"]');
    this.$items = this.$el.find('[data-filter="item"]');
    this.$filteredItems = this.$el.find('[data-filter="item"]');
    this.$container = this.$el.find('[data-filter="container"]');


    this.init();
  }

  init = () => {
    // dynamic import gsap
    this.$select.on('change', this.onSelectChange);

  };

  onSelectChange = (e) => {
    const value = e.target.value;
    this.filterItems(value);
  };

  filterItems = (value) => {

    this.animateOut(() => {
      this.$filteredItems.addClass('d-none');

      if(value === 'all') {
        this.$filteredItems = this.$items;
      }
      else {
        this.$filteredItems = this.$items.filter((index, item) => {
          const ids = $(item).data('value');
          return ids.includes(Number(value));
        });
      }

      this.$filteredItems.removeClass('d-none');

      this.animateIn();
    });
  }

  animateOut = ( onComplete ) => {
    const { duration, stagger, x, ease} = this;

    gsap.to(this.$filteredItems, {
      duration,
      stagger,
      x,
      opacity: 0,
      onComplete: onComplete
    });
  };

  animateIn = () => {
    const { duration, stagger, x, ease} = this;
    gsap.fromTo(this.$filteredItems, {
      opacity: 0,
      x: -x,
    } ,{
      duration,
      stagger,
      opacity: 1,
      x: 0,
      onComplete: () => {
        ScrollTrigger.refresh();
      }
    });
  };

}

export default Filter;